
<gw-audit-top-bar></gw-audit-top-bar>
<gw-audits-navigation></gw-audits-navigation>
<router-outlet></router-outlet>